module.exports = __webpack_public_path__ + "img/de.45759289.svg";